import { currencySymbol } from "@/lib/format";

/**
 * Effective CPM of a closed deal: price ÷ (median views × deliverables)
 * × 1000. Median-first on purpose — Amy v2 negotiates CPM budgets from
 * median views (server-side reads already resolve the _alt pair for YT
 * long-form campaigns). Null when it can't be computed honestly.
 */
export function effectiveCpm(
  negotiatedPrice: number | string | null | undefined,
  medianViews: number | null | undefined,
  deliverables: number | null | undefined
): number | null {
  const price = Number(negotiatedPrice);
  if (!Number.isFinite(price) || price <= 0) return null;
  if (typeof medianViews !== "number" || medianViews <= 0) return null;
  return (price * 1000) / (medianViews * (deliverables || 1));
}

export function formatCpm(cpm: number, currency?: string | null): string {
  const rounded = cpm >= 100 ? Math.round(cpm) : Number(cpm.toFixed(2));
  return `${currencySymbol(currency)}${rounded} CPM`;
}
